import { z } from "zod";

import { bank } from "./banks";

export const saveRegistrySchema = z.object({
  registro_de_matricula: z.object({
    id: z.string(),
    usuario_id: z.string(),
    criado_em: z.coerce.date(),
    titulo: z.string(),
    uf: z.string(),
    numero_do_leilao: z.string(),
    banco: bank,
    inscricao_imobiliaria: z.string(),
    matricula: z.string(),
  }),
  favorito: z.boolean(),
});

export const registrySchema = z.string().nullable();

export const validateRegistrySchema = z.object({
  valido: z.boolean(),
  texto: z.string().nullable(),
});
